import {
  ACTION_RECHECK_XCARD_STATUS__REQUEST,
  ACTION_RECHECK_XCARD_STATUS__SUCCESS,
  ACTION_RECHECK_XCARD_STATUS__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_RECHECK_XCARD_STATUS__REQUEST:
    case ACTION_RECHECK_XCARD_STATUS__SUCCESS:
      return null;

    case ACTION_RECHECK_XCARD_STATUS__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
